export const STATUS_STARTED = 'status_started';
export const STATUS_FINISHED = 'status_finished';
export const STATUS_INTRO = 'status_intro';
